import { render, staticRenderFns } from "./dataV_A.vue?vue&type=template&id=3499daec&scoped=true&"
import script from "./dataV_A.vue?vue&type=script&lang=js&"
export * from "./dataV_A.vue?vue&type=script&lang=js&"
import style0 from "./dataV_A.vue?vue&type=style&index=0&id=3499daec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499daec",
  null
  
)

export default component.exports